import { QUERY_KEYS } from 'api/query-keys';
import { bankAccountService } from 'hq/services';
import { useQuery } from 'react-query';

export const useGetPendingBankAccounts = () => {
  return useQuery(QUERY_KEYS.flexWorkerBankAccounts(), {
    queryFn: async () => await bankAccountService.getPendingBankAccounts(),
  });
};
